import Mutations from '../../odata/mutations';

export default { ...new Mutations('deliveryNote'), ...new Mutations('deliveryNotes') };
